export const WEB_BLOG_ROOT_URL = "https://solitairetripeaks.com/wp-json/";
